import {Field, FieldType, Primitive} from "../../../../Types";
import RawEditStringTextarea from "./forms/RawEditStringTextarea";
import React from "react";
import RawEditStringInput from "./forms/RawEditStringInput";
import RawEditDatetime from "./forms/RawEditDatetime";
import RawEditNumberInput from "./forms/RawEditNumberInput";
import RawEditBooleanInput from "./forms/RawEditBooleanInput";
import RawEditMap from "./forms/RawEditMap";


interface PropsI {
    value: string,
    onChange: (arg: Primitive, invalid?: boolean) => void,
    name: string,
    type: FieldType,
    isSimple: boolean,
    schema?: Field
}

export default function RawEditForm({value, onChange, name, type, isSimple, schema}: PropsI) {

    switch (type) {
        case "map":
            return <RawEditMap value={value} onChange={onChange} map={schema!.map!} />
        case "boolean":
            return <RawEditBooleanInput value={value} onChange={onChange}/>
        case "number":
            return <RawEditNumberInput value={value} onChange={onChange} name={name}/>
        case 'url':
        case 'tel':
        case 'email':
        case 'image':
            return <RawEditStringInput value={value} onChange={onChange} name={name}
                                       type={type === 'email' ? 'email' : type === 'tel' ? 'tel' : 'text'}/>
        case "datetime":
        case "date":
        case "time":
            return <RawEditDatetime value={value} onChange={onChange} name={name}
                                    datetimeFormat={schema?.datetimeFormat}
                                    type={type}/>
        case "json":
        case "string":
            return <RawEditStringTextarea value={value} onChange={onChange} name={name}/>
        case "ref":
            return <div>NO SUPPORT FOR REFS!</div>
        default:
            return <RawEditStringTextarea value={value} onChange={onChange} name={name}/>
    }
}

